module.exports = __webpack_public_path__ + "static/media/image-16.2e0a45d7.jpg";